/**
 * 枚舉
 *
 * ⚠️⚠️ 注意 ⚠️⚠️
 * 枚舉除了根namespace以外, 請都使用扁平的enum
 * 且名稱至少要兩個英文單字組成
 * 因為 namespace 跟 enum 的名稱在 typescript 必須是 unique 的
 */

/**
 * 操作 - 平台 - 名稱
 */
export const EnumPortalName = Object.freeze({

    /**
     * 我的教會
     */
    ADMIN: "admin",

    /**
     * 牧養系統
     */
    SHEPHERD: "shepherd",

    /**
     * APP首頁 (org=4 專屬)
     */
    GLORY: "glory",

})

/**
 * 操作 - 平台 - 路由
 */
export const EnumPortalRouter = Object.freeze({

    /**
     * 我的教會
     */
    ADMIN: "AdminDashboard",

    /**
     * 牧養系統
     */
    SHEPHERD: "ShepherdDashboard",

    /**
     * APP首頁
     */
    GLORY: "GloryDashboard",

})

/**
 * 操作 - 平台 - 首頁路由對照
 *
 * 在只有兩個 portal 的年代, 全站有 8 處寫成
 * `portal === ADMIN ? AdminDashboard : ShepherdDashboard` 的三元運算子。
 * 加第三個 portal 時那 8 處會全部安靜地把 glory 判成 shepherd, 所以一次改成查表。
 *
 * ⚠️ 取值一律配 `?? EnumPortalRouter.ADMIN`:
 *    meta.portal 若是意料外的值, 行為要退化成「回我的教會首頁」,
 *    而不是拿 undefined 去餵 router.push (那會丟例外)。
 */
export const EnumPortalDashboard = Object.freeze({

    [EnumPortalName.ADMIN]: EnumPortalRouter.ADMIN,

    [EnumPortalName.SHEPHERD]: EnumPortalRouter.SHEPHERD,

    [EnumPortalName.GLORY]: EnumPortalRouter.GLORY,

})

/**
 * 操作 - 平台 - 切換器清單
 *
 * 顯示順序即陣列順序。
 *
 * right: 需要的權限「群組代號」; null 表示所有登入者都看得到。
 *        61 是榮耀堂的控制面板群組 —— 後端 dao_admin_user.xml 已把 portal=3 的權限群組
 *        限定給 organization.seq = 4, 所以「權限陣列裡有沒有 61」就等於「是不是榮耀堂」。
 *        前端因此不需要知道 organization uuid (那個值 dev / prod 不同)。
 *        見 hook/usePortal.js。
 */
export const EnumPortalList = Object.freeze([
    {
        portal: EnumPortalName.ADMIN,
        route: EnumPortalRouter.ADMIN,
        subject: "我的教會",
        right: null,
    },
    {
        portal: EnumPortalName.SHEPHERD,
        route: EnumPortalRouter.SHEPHERD,
        subject: "牧養系統",
        right: null,
    },
    {
        portal: EnumPortalName.GLORY,
        route: EnumPortalRouter.GLORY,
        subject: "APP首頁",
        right: 61,
    },
])
